import { colors } from '../../constants';
const MuiButton = {
  sizeLarge: {
    padding: '14px 23px',
    lineHeight: 1.25
  },
  disabled: {},
  sizeSmall: {
    padding: '10px 23px'
  },
  root: {
    lineHeight: 1.3,
    borderRadius: 25,
    padding: '12px 23px'
  },
  text: {
    padding: '10px 23px',
    '&:hover,&:focus': {
      color: 'currentColor'
    }
  },
  textPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.main
    }
  },
  textSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.main
    }
  },
  contained: {
    borderRadius: 25,
    '&$disabled': {
      color: colors.commonColors.white
    },
    '&:hover,&:focus': {
      color: 'currentColor'
    }
  },
  containedPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.contrastText
    }
  },
  containedSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.contrastText
    }
  },
  outlined: {
    borderRadius: 25,
    padding: '10px 23px',
    lineHeight: 1.35,
    color: colors.oriGrey[900],
    border: `1px solid ${colors.oriGrey.A400}`,
    '&:hover,&:focus': {
      color: colors.oriGrey[900],
      border: `1px solid ${colors.oriGrey[900]}`
    }
  },
  outlinedPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.main
    }
  },
  outlinedSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.main
    }
  }
};
export default MuiButton;